"use client";

import { useMemo, useState } from "react";

import type { PortfolioEntry } from "@/data/portfolio";
import { PortfolioCard } from "@/components/portfolio/portfolio-card";

type PortfolioArchiveProps = {
  items: PortfolioEntry[];
};

export function PortfolioArchive({ items }: PortfolioArchiveProps) {
  const categories = useMemo(() => {
    const unique = Array.from(new Set(items.map((item) => item.category)));
    return ["Semua", ...unique];
  }, [items]);

  const [activeCategory, setActiveCategory] = useState<string>(categories[0] ?? "Semua");

  const filteredItems = useMemo(() => {
    if (activeCategory === "Semua") {
      return items;
    }
    return items.filter((item) => item.category === activeCategory);
  }, [items, activeCategory]);

  console.log(filteredItems, "<<filteredItems");
  

  return (
    <div className="space-y-8">
      <div className="flex flex-wrap gap-3">
        {categories.map((category) => {
          const isActive = activeCategory === category;
          return (
            <button
              key={category}
              type="button"
              onClick={() => setActiveCategory(category)}
              className={`rounded-full border px-4 py-2 text-sm font-medium transition ${
                isActive
                  ? "border-primary bg-primary text-white shadow-[0_8px_20px_-12px_hsl(var(--primary))]"
                  : "border-foreground/15 bg-white/60 text-foreground/70 hover:border-primary/40 hover:text-foreground"
              }`}
            >
              {category}
            </button>
          );
        })}
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {filteredItems.map((item) => (
          <div key={`${item.title}-${item.category}`}>
            <PortfolioCard item={item} />
          </div>
        ))}
      </div>
    </div>
  );
}
